import { JobOfferResponse } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore, subscribeOnJobOfferResponseOfChatRoomUpdated, subscribeOnJobOfferResponseUpdated } from '@dinosband/bv-main-client'

import { BvSubscriber } from './manager/subscriber'

interface _ContextType {
  mainStore: MainStore
  chatRoomId?: number
  jobOfferId?: number
}

export class JobOfferResponseSubscriber extends BvSubscriber<JobOfferResponse> {
  context: _ContextType

  constructor (context: _ContextType, callback: (value: JobOfferResponse) => void) {
    super(callback as unknown as (value: JobOfferResponse | JobOfferResponse[]) => void)
    this.context = context
  }

  protected async query () {
    if (!this.context.chatRoomId || !this.context.jobOfferId) {
      return
    }
    return await this.context.mainStore.readJobOfferResponse({ chatRoomId: this.context.chatRoomId })
  }

  protected async subscribe () {
    const chatRoomId = this.context.chatRoomId
    if (chatRoomId) {
      return await this.subscribeResponsesOfChatRoom(chatRoomId)
    } else {
      return await this.subscribeMyResponses()
    }
  }

  protected async subscribeResponsesOfChatRoom (chatRoomId: number) {
    return subscribeOnJobOfferResponseOfChatRoomUpdated(await this.context.mainStore.apollo.getClient(), [chatRoomId], (value) => { this.callback(value) })
  }

  private async subscribeMyResponses () {
    const mainStore = this.context.mainStore
    const userId = mainStore.userId
    if (!userId) {
      return
    }
    return subscribeOnJobOfferResponseUpdated(await mainStore.apollo.getClient(), [], userId, (value) => { this.callback(value) })
  }


}
